var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "manage_dark",
    transform: "translate(-1347 -250)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11409",
    "data-name": "Rectangle 11409",
    width: 24,
    height: 24,
    transform: "translate(1347 250)",
    fill: "#4b4e6d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_maintenance",
    d: "M17.957,3a3.991,3.991,0,0,0-3.6,5.643L4.586,18.414a1.414,1.414,0,0,0,2,2l5.543-5.543L17.453,20.2A1.94,1.94,0,1,0,20.2,17.453l-5.326-5.324,1.486-1.486a3.988,3.988,0,0,0,5.523-2.674,3.9,3.9,0,0,0,.029-1.8.507.507,0,0,0-.854-.227L20,7a1.414,1.414,0,0,1-2-2l1.057-1.057a.507.507,0,0,0-.227-.854A3.878,3.878,0,0,0,17.957,3ZM5.029,3.291a1,1,0,0,0-.609.289l-.84.84a1,1,0,0,0-.125,1.262l.951,1.428A2,2,0,0,0,6.07,8h.516l2.707,2.707,1.414-1.414L8,6.586V6.07a2,2,0,0,0-.891-1.664L5.682,3.455A.994.994,0,0,0,5.029,3.291Z",
    transform: "translate(1346.713 250)",
    fill: "#4b4e6d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageDark);
export default __webpack_public_path__ + "static/media/manage_dark.4d179c3881fea3a3346f1059c5965d4f.svg";
export { ForwardRef as ReactComponent };